import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SearchPipe } from './pipes/search.pipe';
import { UploadModalComponent } from './tools/uploads/upload-modal/upload-modal.component';
import { LoadingStateComponent } from './tools/loading-state/loading-state.component';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';


@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzAvatarModule,
        NzButtonModule,
        NzCardModule,
        NzCollapseModule,
        NzDividerModule,
        NzDrawerModule,
        NzDropDownModule,
        NzFormModule,
        NzGridModule,
        NzIconModule,
        NzInputModule,
        NzListModule,
        NzMessageModule,
        NzModalModule,
        NzNotificationModule,
        NzPaginationModule,
        NzSelectModule,
        NzSpinModule,
        NzStepsModule,
        NzTableModule,
        NzTabsModule,
        NzUploadModule,
        PerfectScrollbarModule,
        SearchPipe,
        UploadModalComponent,
        LoadingStateComponent
    ],
    imports: [
        //RouterModule,
        CommonModule,
        NzAvatarModule,
        NzButtonModule,
        NzCardModule,
        NzCollapseModule,
        NzDividerModule,
        NzDrawerModule,
        NzDropDownModule,
        NzFormModule,
        NzGridModule,
        NzIconModule,
        NzInputModule,
        NzListModule,
        NzMessageModule,
        NzModalModule,
        NzNotificationModule,
        NzPaginationModule,
        NzSelectModule,
        NzSpinModule,
        NzStepsModule,
        NzTableModule,
        NzTabsModule,
        NzUploadModule,
        PerfectScrollbarModule,
        ReactiveFormsModule
    ],
    declarations: [
        SearchPipe,
        UploadModalComponent,
        LoadingStateComponent
    ],
    providers: [
        // ThemeConstantService, 
        // PlacesService                       
    ]
})

export class SharedModule { }
